<template>
    <div class="survey-note-form-ccm">

        <p v-html="$i18n.gt('MESSAGE_REPORT_CCM_REVIEW_SIGNATURE')"></p>

        <b-form inline class="mb-3 ml-2">
            <label>
                <span v-html="$i18n.gt('HEADING_REPORT_TIME_SPENT')"></span>
            </label>
            <b-form-select class="ml-2"
                           v-model="draftSurveyNote.ccm_review_minutes">
                <option v-for="(v, i) in minuteOptions" :key="i"
                        :value="v">
                    {{ v }}
                </option>
            </b-form-select>
        </b-form>

        <b-form-group :label="$i18n.gt('HEADING_REPORT_TASKS_COMPLETED')">
            <div v-for="task in ccmTasks" :key="task.key">
                <b-form-checkbox v-model="draftSurveyNote[task.key]"
                                 :value="1"
                                 :unchecked-value="0"
                                 :disabled="!isRemainingTask(task.key)">
                    {{ $i18n.gt(task.labelKey) }}
                </b-form-checkbox>
            </div>
        </b-form-group>

        <div class="row mt-1 mx-1">
            <span v-html="$i18n.gt('MESSAGE_REPORT_CCM_REVIEW_SIGNATURE_NOTE_INTRO')"></span>
        </div>

    </div>
</template>

<script>
    import * as _ from 'lodash'

    /**
     * Form for attributes specific to a CCM SurveyNote
     */
    export default {
        name: 'SurveyNoteFormCcm',
        data () {
            return {
                minuteOptions: _.range(1, 31),
                ccmTasks: [
                    { key: 'ccm_demographics', labelKey: 'LABEL_CCM_DEMOGRAPHICS' },
                    { key: 'ccm_problem_list', labelKey: 'LABEL_CCM_PROBLEM_LIST' },
                    { key: 'ccm_symptom_management', labelKey: 'LABEL_CCM_SYMPTOM_MANAGEMENT' },
                    { key: 'ccm_medication_use', labelKey: 'LABEL_CCM_MEDICATION_USE' },
                    { key: 'ccm_allergies', labelKey: 'LABEL_CCM_ALLERGIES' },
                    { key: 'ccm_clinical_summary', labelKey: 'LABEL_CCM_CLINICAL_SUMMARY' },
                    { key: 'ccm_goals', labelKey: 'LABEL_CCM_GOALS' },
                ]
            }
        },
        computed: {
            draftSurveyNote() {
                return this.$store.state.draftSurveyNote
            },
            provider() {
                return this.$store.state.patientParticipantProvider
            }
        },
        methods: {
            isRemainingTask (key) {
                return !_.isEmpty(this.provider) && this.provider.currentChronicCareTasksRemaining.indexOf(key) != -1
            },
        },
    }
</script>
